import React from 'react';
import { Product, Branch } from '../types';
import ProductCard from './ProductCard';
import { Clock } from 'lucide-react';

interface RecentlyViewedProps {
    products: Product[];
    currentBranch: Branch;
    onProductClick: (product: Product) => void;
}

const RecentlyViewed: React.FC<RecentlyViewedProps> = ({ products, currentBranch, onProductClick }) => {
    if (products.length === 0) return null;

    return (
        <section className="pt-8 pb-12 bg-black/50 border-t border-zinc-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center gap-3 mb-8">
                    <Clock className="w-6 h-6 text-white" />
                    <h2 className="text-2xl font-display font-bold text-white uppercase italic tracking-tighter">Visto Recientemente</h2>
                    <div className="h-[1px] flex-grow bg-gradient-to-r from-white/30 to-transparent" />
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
                    {products.map(product => (
                        <div key={`recent-${product.id}`} className="h-full">
                            <ProductCard
                                product={product}
                                currentBranch={currentBranch}
                                onProductClick={onProductClick}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default RecentlyViewed;
